export default __webpack_public_path__ + "static/media/Dansn_Mock-up_iMac2.b26722f8.jpg";